import type { PagesConfig, SectionConfig, TemplateSettings } from '../types'
import { DisplayConditionStoreEnum, SectionTypeEnum, SectionViewTypeEnum } from '../types'
import { FIXED_PAGE_CONFIGS } from './pages'
import { COVER_PAGE_ID, NEXT_STEPS_PAGE_ID } from './pages/custom/constants'
import { CUSTOM_PAGE_CONFIGS } from './pages/custom/pages'
import { PREDEFINED_VIEW_AND_PAGES_CONFIGS } from './views'
import { ComposedViewEnum } from './views/composed/constants'
import { PredefinedViewEnum } from './views/predefined/constants'

const DEFAULT_PAGES: PagesConfig[] = [...CUSTOM_PAGE_CONFIGS, ...FIXED_PAGE_CONFIGS]

const DEFAULT_SECTIONS_CONFIG: SectionConfig[] = [
  {
    sectionId: SectionTypeEnum['Home'],
    views: [
      {
        type: SectionViewTypeEnum.CustomView,
        displayConditions: [],
        pageId: COVER_PAGE_ID,
      },
    ],
  },
  {
    sectionId: SectionTypeEnum['Energy'],
    views: [
      PREDEFINED_VIEW_AND_PAGES_CONFIGS[PredefinedViewEnum.Energy],
      PREDEFINED_VIEW_AND_PAGES_CONFIGS[PredefinedViewEnum.SystemHardware],
    ],
  },
  {
    sectionId: SectionTypeEnum['Savings'],
    views: [
      PREDEFINED_VIEW_AND_PAGES_CONFIGS[PredefinedViewEnum.OnlineSavingsCurrentNow],
      PREDEFINED_VIEW_AND_PAGES_CONFIGS[PredefinedViewEnum.OnlineSavingsCurrentFuture],
      PREDEFINED_VIEW_AND_PAGES_CONFIGS[PredefinedViewEnum.OnlineSavingsCurrentCumulative],
      PREDEFINED_VIEW_AND_PAGES_CONFIGS[PredefinedViewEnum.ElectrifiedSavings],
    ],
  },
  {
    sectionId: SectionTypeEnum['Go'],
    views: [
      {
        type: SectionViewTypeEnum.ComposedViews,
        displayConditions: [],
        name: ComposedViewEnum.GO,
        views: [
          PREDEFINED_VIEW_AND_PAGES_CONFIGS[PredefinedViewEnum.Disclaimer],
          PREDEFINED_VIEW_AND_PAGES_CONFIGS[PredefinedViewEnum.Checkout],
          {
            type: SectionViewTypeEnum.CustomView,
            displayConditions: [
              {
                name: DisplayConditionStoreEnum.NextStep,
                payload: {
                  storeField: 'next_step',
                  displayWhenProjectRecorded: true,
                },
              },
            ],
            pageId: NEXT_STEPS_PAGE_ID,
          },
        ],
      },
    ],
  },
]

export const LATEST_DEFAULT_TEMPLATE_SETTING = '3.2'

// SPLITTING AS INDIVIDUAL CHUNK, DO NOT DIRECT IMPORT RAW SETTING
export const getDefaultGrapesSwipeTemplateSetting = () => {
  const DEFAULT_TEMPLATE_SETTING: TemplateSettings = {
    version: LATEST_DEFAULT_TEMPLATE_SETTING,
    name: 'default',
    designConfig: {
      assets: [],
      styles: [], // Managed by grapesjs to store user edited styles. The styles for OpenSolar custom page such as cover page are moved to global sass
      pages: DEFAULT_PAGES,
      globalState: {},
      pageStates: {},
      sections: DEFAULT_SECTIONS_CONFIG,
      modifiedAt: new Date(),
    },
  }

  return DEFAULT_TEMPLATE_SETTING
}
